export const envConfig = {
  isProduction: process.env.NODE_ENV === 'production',
  appVersion: process.env.NEXT_PUBLIC_APP_VERSION,
  sentry: {
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? 'staging',
  },
  salesforce: {
    chat: {
      chatName: process.env.NEXT_PUBLIC_SALESFORCE_CHAT_NAME,
      queueId: process.env.NEXT_PUBLIC_SALESFORCE_QUEUE_ID,
      queueName: process.env.NEXT_PUBLIC_SALESFORCE_QUEUE_NAME,
    },
  },
};
